import React from 'react';

export const FilterIcon = (props) => {
  return (
    <svg viewBox='0 0 30 30' fill='currentColor' height='1em' width='1em' {...props}>
      <g id='icon/filter' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <path
          d='M4.25,7.875 L25.75,7.875 L25.75,10.25 L4.25,10.25 L4.25,7.875 Z M8.59338379,13.8125 L21.4066162,13.8125 L21.4066162,16.1875 L8.59338379,16.1875 L8.59338379,13.8125 Z M12.0651855,19.75 L17.9348145,19.75 L17.9348145,22.125 L12.0651855,22.125 L12.0651855,19.75 Z'
          id='Shape'
          fill='currentColor'
          fillRule='nonzero'
        ></path>
      </g>
    </svg>
  );
};
